import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { DataGrid, GridToolbar, deDE } from '@mui/x-data-grid';

import { ThemeProvider, createTheme } from '@mui/material/styles'
import config from '../../../../../run-config'

const dgTheme = createTheme({
  typography: {
    htmlFontSize: 15,
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: config.primary,
    },
    secondary: { 
      main: config.secondary  
    },
  },
}, deDE);


const styles = {
  dataGridRoot: {
    border: 'none', 
  },
};


class DataGridVisualizer extends Component {
  render() {
    const { data, classes, options } = this.props;
    const { columns } = data[0]

    const transformedColumns = columns.map((c) => ({
      field: c,
      headerName: c,
      width:150
    }))

    const transformedData = data[0].data.map(item => ({ ...item.values }));

    const transformRow = transformedData.map((r, index) => {
      const dynamicRow = {};
      columns.forEach((field, columnIndex) => {
        dynamicRow[field] = r[columnIndex];
      });
      return { id: index, ...dynamicRow };
    });


    return (
      <div style={{ width: '100%' }}>
      <ThemeProvider theme={dgTheme}>
        <DataGrid
         initialState={{
              pagination: { paginationModel: { pageSize: 25 } },
            }}
          pageSizeOptions={[10, 25, 50]}
          autoHeight
          disableSelectionOnClick
          disableDensitySelector
          disableColumnMenu
          rows={transformRow}
          columns={transformedColumns}
          components={{
            Toolbar: GridToolbar,
          }}
          sx={styles.dataGridRoot}
          componentsProps={{
            toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: { disableToolbarButton: true },         
              }
          }}
        />
        </ThemeProvider>
      </div>
    );
  }
}

DataGridVisualizer.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  options: PropTypes.object,
};

DataGridVisualizer.defaultProps = {
  options: null,
};

export default withStyles(styles)(DataGridVisualizer);
